import { Icon } from "@bd/ui-kit";
import { setMyPlayer, useGame } from "../store";
import { t, tp } from "../i18n";

/** Online: shown while you look around a cousin's studio. Nothing can be changed while visiting. */
export function VisitBanner() {
  const game = useGame((s) => s.game);
  const visiting = useGame((s) => s.visiting);
  const online = useGame((s) => s.online);
  const set = useGame((s) => s.set);
  const c = game?.companies.find((x) => x.id === visiting);
  if (!c || !online) return null;
  const back = () => {
    setMyPlayer(online.playerId);
    set({ visiting: null, screen: { kind: "cousins" }, selectedRoom: null, closeup: null });
  };
  return (
    <div className="hud-tl">
      <div className="panel visit-banner stack" style={{ gap: 6 }} aria-label={t("Visiting")} data-testid="visit-banner">
        <strong>{c.name}</strong>
        <span className="ichips">
          {c.pets.length > 0 && <span className="ichip" title={t("Say hello to {pets}.", { pets: c.pets.map((p) => p.name).join(` ${t("and")} `) })}><Icon name="pet" size={14} />{c.pets.map((p) => p.name).join(", ")}</span>}
          <span className="ichip" title={tp(c.stats.awards, "{n} award on the shelf.", "{n} awards on the shelf.")}><Icon name="trophy" size={14} color="var(--gold)" />{c.stats.awards}</span>
        </span>
        <button className="btn primary small" onClick={back} title={t("Back to my studio")} data-testid="visit-back"><Icon name="back" size={16} />{t("My studio")}</button>
      </div>
    </div>
  );
}
